/**
 * 企業グループの色プリセットと表示クラスを集約する。
 * バックエンドの ALLOWED_COLORS と同期する 8 色。
 */

export const COMPANY_GROUP_COLORS = [
  "slate",
  "gray",
  "red",
  "orange",
  "amber",
  "lime",
  "sky",
  "violet",
] as const;

export type CompanyGroupColor = (typeof COMPANY_GROUP_COLORS)[number];

const COLOR_CLASS_MAP: Record<CompanyGroupColor, string> = {
  slate: "bg-slate-200 text-slate-800",
  gray: "bg-gray-200 text-gray-800",
  red: "bg-red-200 text-red-800",
  orange: "bg-orange-200 text-orange-800",
  amber: "bg-amber-200 text-amber-800",
  lime: "bg-lime-200 text-lime-800",
  sky: "bg-sky-200 text-sky-800",
  violet: "bg-violet-200 text-violet-800",
};

/** 一覧の左に置く小さな丸ドット用 (Tailwind の bg-{color}-400)。 */
const COLOR_DOT_CLASS_MAP: Record<CompanyGroupColor, string> = {
  slate: "bg-slate-400",
  gray: "bg-gray-400",
  red: "bg-red-400",
  orange: "bg-orange-400",
  amber: "bg-amber-400",
  lime: "bg-lime-400",
  sky: "bg-sky-400",
  violet: "bg-violet-400",
};

const FALLBACK_CLASS = "bg-slate-100 text-slate-700";
const FALLBACK_DOT_CLASS = "bg-slate-300";

/**
 * 企業グループの ``color`` 値からバッジ表示用の Tailwind クラスを返す。
 * @param {string | null | undefined} color companyGroups.color の値
 * @return {string} Tailwind クラス文字列
 */
export function companyGroupColorClass(
  color: string | null | undefined,
): string {
  if (color == null) {
    return FALLBACK_CLASS;
  }
  return COLOR_CLASS_MAP[color as CompanyGroupColor] ?? FALLBACK_CLASS;
}

/**
 * 企業グループの ``color`` 値から丸ドット用の Tailwind 背景色クラスを返す。
 * 一覧画面でグループ名の左に小さな丸を置くなど、識別子としてのみ色を伝える用途。
 * @param {string | null | undefined} color companyGroups.color の値
 * @return {string} Tailwind 背景色クラス
 */
export function companyGroupDotClass(color: string | null | undefined): string {
  if (color == null) {
    return FALLBACK_DOT_CLASS;
  }
  return COLOR_DOT_CLASS_MAP[color as CompanyGroupColor] ?? FALLBACK_DOT_CLASS;
}
